import { Base, Component } from '@/vue-property-decorator'
import { Col, Layout, Row } from '@/plugins/ant-design-vue/tsx-support'
import { useMainStore } from '@/store/index'
import BusinessUtils from '@/utils/business-utils'
import CountTime from '@/layouts/components/countTime'
import LogoBox from '../logo-box'
import SwitchCurrency from '@/components/business-components/switch-currency'
import SwitchLang from '@/components/business-components/switch-lang'
import style from './style.module.scss'

interface ScopedSlots {
  collapsedIcon?: void
  countTime?: void
  rightCol?: void
  holidayTheme?: void
}

@Component<PCHeaderLayout>({
  name: 'PCHeaderLayout'
})
export default class PCHeaderLayout extends Base<
  unknown,
  unknown,
  unknown,
  ScopedSlots
> {
  private mainStore = useMainStore()

  render() {
    const { hasLogined, showMusic, language } = this.mainStore

    return (
      <Layout.Tsx
        class={{
          [style.pcHeader]: true,
          [style['header-vi_VN']]: language === 'vi_VN',
          ['pcHeader']: true
        }}
      >
        {this.$scopedSlots.collapsedIcon?.()}
        <Layout.Sider.Tsx
          width={BusinessUtils.px2rem(220)}
          height={BusinessUtils.px2rem(56)}
          trigger={null}
          key="header-slider"
          collapsible
        >
          {/* logo区,需根据站点取接口数据进行客制化 */}
          <div class={style.logoWrap}>
            <LogoBox />
          </div>
        </Layout.Sider.Tsx>
        <div class={'headerContainer'} key="headerContainer">
          <div
            class={[
              'headerContainerWrap',
              style.headerContainerWrap,
              !showMusic ? style.wrapFlexEnd : ''
            ]}
          >
            <div
              class={[
                style.headerLeft,
                'headerLeft',
                hasLogined ? style.loginedHeaderLeft : ''
              ]}
            >
              {this.$scopedSlots.countTime?.() || (
                <div class={[style.countTime, 'countTime']}>
                  <CountTime />
                </div>
              )}

              <div id="header-switchLang" class={style.headerSwitchLang}>
                <SwitchLang
                  getPopupContainer={() =>
                    document.getElementById('header-switchLang') as HTMLElement
                  }
                  isHeaderSwitch={true}
                  border={true}
                />
              </div>
              {!hasLogined && (
                <div
                  id="header-switchCurrency"
                  class={style.headerSwitchCurrency}
                >
                  <SwitchCurrency
                    getPopupContainer={() =>
                      document.getElementById(
                        'header-switchCurrency'
                      ) as HTMLElement
                    }
                    isHeaderSwitch={true}
                  />
                </div>
              )}

              {this.$scopedSlots.holidayTheme?.()}
            </div>
            <Row.Tsx
              type={'flex'}
              class={[
                style.headerRight,
                hasLogined ? style.loginedHeaderRight : ''
              ]}
              align={'middle'}
            >
              <Col.Tsx class={style.rightCol}>
                {this.$scopedSlots.rightCol?.()}
              </Col.Tsx>
            </Row.Tsx>
          </div>
        </div>
      </Layout.Tsx>
    )
  }
}
